<template>
  <div>Signature entry</div>
</template>

<script>
export default {
  name: "SignatureEntry",
  props: ["signatureEntry"]
};
</script>